import React from 'react';

export interface CardCreationLayoutProps {
  header: React.ReactNode;
  styles: Record<string, string>;
  cdnPrefix: string;
  children?: React.ReactNode;
}

export function CardCreationLayout({ header, styles, children }: CardCreationLayoutProps) {
  return (
    <div className={styles.wrapper}>
      {/* Header */}
      {header}
      <div className={styles.body}>
        <div className={styles.content}>
          {children}
        </div>
      </div>
    </div>
  );
}

export default CardCreationLayout;
